import axios from "axios";
import { API_URL } from "./config";
import { getSession } from "./session";

// Render's free tier can take ~50s to wake up.
const client = axios.create({ baseURL: API_URL, timeout: 70000 });

const auth = () => ({ headers: { Authorization: `Bearer ${getSession().token}` } });

export const fetchProducts = async () => (await client.get("/products")).data;

export const searchProducts = async (text) => {
  try {
    return (await client.get("/products/search", { params: { value: text } })).data;
  } catch (e) {
    // The backend answers 404 when nothing matches.
    if (e.response && e.response.status === 404) return [];
    throw e;
  }
};

export const login = async (username, password) =>
  (await client.post("/auth/login", { username, password })).data;

export const register = async (username, password) =>
  (await client.post("/auth/register", { username, password })).data;

export const fetchCart = async () => (await client.get("/cart", auth())).data;

// qty 0 removes the item. Returns the updated cart: [{ productId, qty }].
export const setCartQty = async (productId, qty) =>
  (await client.post("/cart", { productId, qty }, auth())).data;

export const checkout = async (addressId) =>
  (await client.post("/cart/checkout", { addressId }, auth())).data;

export const fetchAddresses = async () => (await client.get("/user/addresses", auth())).data;

export const addAddress = async (address) =>
  (await client.post("/user/addresses", { address }, auth())).data;

export const deleteAddress = async (id) =>
  (await client.delete(`/user/addresses/${id}`, auth())).data;

export const errorMessage = (e) => {
  if (e && e.response && e.response.data && e.response.data.message) return e.response.data.message;
  if (e && e.code === "ECONNABORTED") return "The server took too long to respond. Please try again.";
  return "Something went wrong. Please check your connection and try again.";
};

// The backend reports stale logins with a 400 or 401 and one of these messages.
export const isAuthError = (e) => {
  const status = e && e.response && e.response.status;
  const message = (e && e.response && e.response.data && e.response.data.message) || "";
  return status === 401 || /token|no longer exists/i.test(message);
};
